/* BLOG-FCP-HEAD-001: head bootstrap moved non-critical inline scripts to external deferred asset */
(function(){
  var OTF_RE = /SuisseIntl.*\.otf(?:\?|$)/i;
  function removeNode(node) {
    if (!node || !node.remove) return;
    node.remove();
  }

  function sweep() {
    var list = document.querySelectorAll('link[rel="preload"][as="font"],link[rel="stylesheet"],style');
    for (var i = 0; i < list.length; i++) {
      var node = list[i];
      var href = ((node.getAttribute && node.getAttribute('href')) || '') + ' ' + (node.href || '');
      var txt = node.textContent || '';
      if (OTF_RE.test(href) || (/@font-face/i.test(txt) && /SuisseIntl/i.test(txt))) {
        removeNode(node);
      }
    }
  }

  sweep();
  try {
    new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes || [];
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (!node || node.nodeType !== 1) continue;
          var href = ((node.getAttribute && node.getAttribute('href')) || '') + ' ' + (node.href || '');
          var txt = node.textContent || '';
          if (OTF_RE.test(href) || (node.tagName === 'STYLE' && /SuisseIntl/i.test(txt))) {
            removeNode(node);
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (err) {
    /* non-blocking; mutation observer is optional */
  }
})();

(function() {
  if (!document || !document.documentElement) return;
  document.documentElement.className = document.documentElement.className.replace('no-js', 'js');
  if (window.Shopify && window.Shopify.designMode) {
    document.documentElement.classList.add('shopify-design-mode');
  }
})();


/* FIX-GA4-REALTIME-SITEWIDE-20260714: Google tag initialization is managed once by Shopify's Google & YouTube app pixel. */
